import { render, staticRenderFns } from "./orthodontic-instructions.vue?vue&type=template&id=4cb26268&scoped=true"
import script from "./orthodontic-instructions.vue?vue&type=script&lang=js"
export * from "./orthodontic-instructions.vue?vue&type=script&lang=js"
import style0 from "./orthodontic-instructions.vue?vue&type=style&index=0&id=4cb26268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb26268",
  null
  
)

export default component.exports